import { Incentive } from './incentive';

export const MOCKINCENTIVES: Incentive[] = [
  {
    incentive: 'Title',
    category: 'incremental',
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut imperdiet mi nec tellus scelerisque auctor ut ac arcu. '
  }
];


// WEBPACK FOOTER //
// /Users/Myrberg/Documents/spring_repo1/spring-app/src/app/base/components/kanban/components/strategy-overview/incentives/mock-incentives.ts